import React, {ReactFragment, useContext} from "react";
import {createUseStyles} from "react-jss";
import GetReady from "./common/GetReady";
import Waiting from "./player/Waiting";
import InProgress from "./shared/InProgress";
import {HostBubble} from "./common/HostBubble";
import Sounds from "./sound/Sounds";
import {EngageAppContext} from "../App";
import {TriviaStatus} from "../state/state";
import Background, {BackgroundType} from "engage-client/components/Background";
import HostBubbleContextProvider from "../contexts/HostBubbleContext";
import ChatContextProvider from "../contexts/ChatContext";

const useStyles = createUseStyles({
	player: {
		width:"100%",
		height: "100%",
	}
});


export default function Player() {
	const {appState} = useContext(EngageAppContext.current);
	const classes = useStyles();
	let content: ReactFragment;

	if(appState.common.state === TriviaStatus.Pending) {
		content = <Waiting/>;
	} else if(appState.common.state === TriviaStatus.Starting) {
		content = <GetReady sharedDisplay={false}/>;
	} else {
		content = <InProgress sharedDisplay={false}/>;
	}

	let type:BackgroundType = BackgroundType.Main;
	if(appState.common.state === TriviaStatus.Pending) {
		type = BackgroundType.Welcome;
	} else if(appState.common.state === TriviaStatus.Starting) {
		type = BackgroundType.GetStarted;
	}

	return (
		<Background type={type}>
			<HostBubbleContextProvider>
				<ChatContextProvider>
					<div className={classes.player}>
						{content}
					</div>
					<HostBubble />
				</ChatContextProvider>
			</HostBubbleContextProvider>
			<Sounds/>
		</Background>
	);
}
